import { jsxs as I, jsx as i } from "react/jsx-runtime";
import { useEffect as T, memo as U, useMemo as $, useCallback as u } from "react";
import v from "./selector/slicers/SingleSlicerSelector.js";
import { getDimensionOption as q } from "./selector/utils.js";
import { SortableContainerContext as z, getIndexFromID as B, SortableOverlay as G, SortableItem as H, getIdFromIndex as w } from "@biron-data/react-components";
import { u as L } from "./styled-components.browser.esm-BFmoFexH.js";
import "./useResizeDetector-sfyDtky2.js";
import { useLanguageResolver as J } from "@biron-data/react-contexts";
import { useSelectorLayout as K } from "./layout/useSelectorLayout.js";
const M = (o, d, r) => {
  T(
    () => {
      d !== r && r && (o == null || o(r));
    },
    [o, d, r]
  );
}, S = "date_slicer", g = U(function({
  value: d = [],
  availableDimensions: r,
  unavailableDimensions: _,
  disabled: p,
  multiple: a = !1,
  onChange: t,
  getPopupContainer: y,
  configuration: b,
  getMoreInformationLink: D
}) {
  const m = J(), f = K(), c = $(
    () => {
      const e = d.filter((s, l) => a || l === 0).filter((s) => {
        switch (s.type) {
          case "dimension":
            return r.find((l) => l.code === s.dimensionCode);
          case "date":
            return !0;
          default:
            return s;
        }
      });
      return e.length === d.length ? d : e;
    },
    [r, d, a]
  );
  M(t, d, c);
  const O = u(
    (e) => {
      t == null || t(c.slice(0, e).concat(c.slice(e + 1)));
    },
    [c, t]
  ), j = u(
    (e, s) => {
      s === S ? t == null || t(c.slice(0, e).concat([{ type: "date", isDefault: !1 }], c.slice(e + 1))) : t == null || t(c.slice(0, e).concat([{ dimensionCode: s, type: "dimension", isDefault: !1 }], c.slice(e + 1)));
    },
    [c, t]
  ), k = u(
    (e) => {
      if (e === S) {
        const s = c.findIndex((l) => l.type === "date");
        if (s === -1)
          t == null || t([...c, { type: "date", isDefault: !1 }]);
        else {
          const l = Object.assign([], c);
          l[s].isDefault = !1, t == null || t(l);
        }
      } else
        t == null || t([...c, { dimensionCode: e, type: "dimension", isDefault: !1 }]);
    },
    [c, t]
  ), A = u(
    (e, s, l) => {
      const E = c;
      E[s].isDefault = !1, E[l].isDefault = !1, t == null || t(e);
    },
    [t, c]
  ), x = $(
    () => {
      const e = c.find((s) => s.type === "date");
      return [
        {
          label: m.get("date-slicer-option-label"),
          value: S,
          selectorLabel: `${m.get("date-slicer-option-label")}${e != null && e.isDefault ? ` - ${m.get("by-default")}` : ""}`,
          disabled: e && !e.isDefault
        },
        ...q(r, _).map((s) => ({
          ...s,
          selectorLabel: s.label
        }))
      ];
    },
    [c, m, r, _]
  ), R = u((e) => {
    switch (e.type) {
      case "dimension":
        return e.dimensionCode;
      case "date":
        return S;
      default:
        return e;
    }
  }, []), F = $(() => f === "default" ? N : Q, [f]);
  return /* @__PURE__ */ I("div", { children: [
    /* @__PURE__ */ i(
      z,
      {
        value: c,
        handleChange: A,
        overlayRender: (e) => {
          const s = c[B(e)];
          return /* @__PURE__ */ i(G, { activeId: e, children: /* @__PURE__ */ i(
            v,
            {
              id: e,
              value: R(s),
              availableDimensions: r,
              disabled: p,
              options: x,
              canRemove: !0,
              getPopupContainer: y,
              configuration: b,
              isDefault: s.isDefault,
              getMoreInformationLink: D,
              layout: f
            }
          ) });
        },
        children: c == null ? void 0 : c.map(
          (e, s) => /* @__PURE__ */ i(
            H,
            {
              id: w(s),
              children: /* @__PURE__ */ i(
                v,
                {
                  id: w(s),
                  value: R(e),
                  availableDimensions: r,
                  disabled: p,
                  options: x,
                  canRemove: !0,
                  onDelete: O,
                  onSelect: (l) => j(s, l),
                  getPopupContainer: y,
                  configuration: b,
                  isDefault: e.isDefault,
                  getMoreInformationLink: D,
                  layout: f
                }
              )
            },
            `${R(e)}-${w(s)}`
          )
        )
      }
    ),
    /* @__PURE__ */ i(F, { children: !p && (a || c.length === 0) && /* @__PURE__ */ i(v, { id: c.length, availableDimensions: r, options: x, canRemove: !1, onSelect: (e) => k(e), getPopupContainer: y, getMoreInformationLink: D, layout: f }) })
  ] });
}), N = L.div`
    width: ${100 - 100 / 24 - 3}%;
    margin-left: ${100 / 24}%;
`, Q = L.div`
    width: 100%;
`;
export {
  g as S,
  M as p
};
//# sourceMappingURL=SlicerSelector-VIUZXwzA.js.map
